module.exports = __webpack_public_path__ + "img/banner.8abd935e.png";